var _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _radialGradient8, _radialGradient9, _radialGradient10, _radialGradient11, _radialGradient12, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAirflow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 256,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 256",
    width: 256,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: ".000016%",
    cy: "99.999994%",
    gradientTransform: "matrix(.832531 0 0 .832531 0 .167469)",
    r: "120.115697%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c812"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006e00"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: ".000006%",
    cy: "-.000385%",
    gradientTransform: "matrix(0 .832534 -.832531 0 -.000003 -.000004)",
    r: "120.115697%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#56affd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04a3ff"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: "99.999984%",
    cy: ".000006%",
    gradientTransform: "matrix(-.832531 0 0 -.832531 1.832531 0)",
    r: "120.115697%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#df1f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#560d00"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: "99.999994%",
    cy: "100.000694%",
    gradientTransform: "matrix(0 -.832536 .832531 0 .167463 1.832543)",
    r: "120.115697%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00fffd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00daff"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: ".000355%",
    cy: "99.999994%",
    gradientTransform: "matrix(1 0 0 1.00000352 0 -.000004)",
    r: "99.99964%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#008200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007500"
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: ".000006%",
    cy: ".000091%",
    gradientTransform: "matrix(0 1 -1.00000003 0 .000001 .000001)",
    r: "99.999904%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3166d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a509e"
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: "100.000355%",
    cy: ".000006%",
    gradientTransform: "matrix(-1 0 0 -.99999654 2.000008 0)",
    r: "100.00035%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8e1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b0b00"
  }))), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: "99.999994%",
    cy: "100.001042%",
    gradientTransform: "matrix(0 -1 1.00000701 0 -.000017 2.00001)",
    r: "99.999333%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0090c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005d8c"
  }))), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: "0%",
    cy: "99.998902%",
    gradientTransform: "matrix(1 0 0 .99998603 0 .000014)",
    r: "99.999992%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00cd1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e950"
  }))), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: "-.000007%",
    cy: "-.000012%",
    gradientTransform: "matrix(0 1 -1.00000076 0 0 0)",
    r: "99.999992%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b1c8fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ec3fd"
  }))), _radialGradient11 || (_radialGradient11 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: "99.999987%",
    cy: "-.000007%",
    gradientTransform: "matrix(-1 0 0 -1.00000076 2 0)",
    r: "99.999992%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e12a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b62f00"
  }))), _radialGradient12 || (_radialGradient12 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: "100.000007%",
    cy: "100%",
    gradientTransform: "matrix(0 -1 1.00001695 0 -.000017 2)",
    r: "99.998364%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b6dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m179.2 230.4h76.8l-122.88-102.4c-1.687 37.193 14.687 73.58 46.08 102.4",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m25.6 179.2v76.8l102.4-122.88c-1.746-.079-3.483-.118-5.225-.118-35.36.002-69.708 16.279-97.175 46.198",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m0 25.6 122.88 102.4c1.687-37.192-14.687-73.58-46.08-102.4z",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m230.4 0-102.4 122.879c37.193 1.688 73.58-14.687 102.4-46.08z",
    fill: "url(#d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m128 128c-11.479 29.755-9.745 60.086 5.12 89.601 15.36 7.679 28.16 12.799 46.08 12.799-31.393-28.82-47.767-65.207-46.08-102.4z",
    fill: "url(#e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m38.4 133.12c-7.679 15.361-12.8 28.16-12.8 46.08 28.819-31.393 65.207-47.766 102.4-46.08v-5.12c-12.944-4.993-25.994-7.486-39.04-7.486-16.946.001-33.884 4.207-50.56 12.606",
    fill: "url(#f)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m122.88 128h5.12c11.478-29.755 9.745-60.087-5.12-89.6-15.36-7.68-28.159-12.8-46.08-12.8 31.393 28.82 47.767 65.208 46.08 102.4",
    fill: "url(#g)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m128 122.879v5.121c29.755 11.478 60.086 9.744 89.6-5.121 7.68-15.358 12.8-28.158 12.8-46.08-28.82 31.393-65.207 47.768-102.4 46.08",
    fill: "url(#h)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m71.68 166.4 61.44 51.201c-14.865-29.515-16.599-59.846-5.12-89.601-1.776-.592-3.858-.876-6.158-.876-17.599.001-47.898 16.635-50.162 39.276",
    fill: "url(#i)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m38.4 133.12c29.514-14.865 59.845-16.598 89.6-5.12 5.12-15.359-12.8-53.76-38.4-56.32z",
    fill: "url(#j)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m128 128c15.36 5.12 53.759-12.8 56.32-38.4l-61.44-51.2c14.865 29.513 16.598 59.845 5.12 89.6",
    fill: "url(#k)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m128 128c-5.12 15.361 12.8 53.76 38.4 56.32l51.2-61.441c-29.514 14.865-59.845 16.599-89.6 5.121",
    fill: "url(#l)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m127.9998 121.6004c3.535 0 6.4 2.865 6.4 6.399 0 3.536-2.865 6.401-6.4 6.401-3.534 0-6.399-2.865-6.399-6.401 0-3.534 2.865-6.399 6.399-6.399"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirflow);
export default __webpack_public_path__ + "static/media/airflow.08b4e5129bfa39fc31a54cb5e5e6fbe0.svg";
export { ForwardRef as ReactComponent };